import { getCarMessage,getRequestRepairList,insertRequestRepair,updateRequestRepair,deleteRequestRepair,getRequestRepair,getRepair,updateUrgeCount,updateRepairState,updateCloseTime,getRepairList,updateRepairUser,insertRepair,abandonRequestRepair } from "../../api/config/modules/RepairManagement";

const state = {
    getCarMessage: {},
    getRequestRepairList: {},
    insertRequestRepair: {},
    updateRequestRepair: {},
    deleteRequestRepair: {},
    getRequestRepair: {},
    getRepair: {},
    updateUrgeCount: {},
    updateRepairState: {},
    updateCloseTime: {},
    getRepairList: {},
    updateRepairUser: {},
    insertRepair: {},
    abandonRequestRepair: {}
};

const mutations = {
  SET_GETCARMESSAGE: (state, getCarMessage) => {
    state.getCarMessage = getCarMessage;
  },
  SET_GETREQUESTREPAIRLIST: (state, getRequestRepairList) => {
    state.getRequestRepairList = getRequestRepairList;
  },
  SET_INSERTREQUESTREPAIR: (state, insertRequestRepair) => {
    state.insertRequestRepair = insertRequestRepair;
  },
  SET_UPDATEREQUESTREPAIR: (state, updateRequestRepair) => {
    state.updateRequestRepair = updateRequestRepair;
  },
  SET_DELETEREQUESTREPAIR: (state, deleteRequestRepair) => {
    state.deleteRequestRepair = deleteRequestRepair;
  },
  SET_GETREQUESTREPAIR: (state, getRequestRepair) => {
    state.getRequestRepair = getRequestRepair;
  },
  SET_GETREPAIR: (state, getRepair) => {
    state.getRepair = getRepair;
  },
  SET_UPDATEURGECOUNT: (state, updateUrgeCount) => {
    state.updateUrgeCount = updateUrgeCount;
  },
  SET_UPDATEREPAIRSTATE: (state, updateRepairState) => {
    state.updateRepairState = updateRepairState;
  },
  SET_UPDATECLOSETIME: (state, updateCloseTime) => {
    state.updateCloseTime = updateCloseTime;
  },
  SET_GETREPAIRLIST: (state, getRepairList) => {
    state.getRepairList = getRepairList;
  },
  SET_UPDATEREPAIRUSER: (state, updateRepairUser) => {
    state.updateRepairUser = updateRepairUser;
  },
  SET_INSERTREPAIR: (state, insertRepair) => {
    state.insertRepair = insertRepair;
  },
  SET_ABANDONREQUESTREPAIR: (state, abandonRequestRepair) => {
    state.abandonRequestRepair = abandonRequestRepair;
  },
};

const actions = {
  GET_GETCARMESSAGE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        getCarMessage(data)
        .then((res) => {
          commit("SET_GETCARMESSAGE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_GETREQUESTREPAIRLIST: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        getRequestRepairList(data)
        .then((res) => {
          commit("SET_GETREQUESTREPAIRLIST", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_INSERTREQUESTREPAIR: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        insertRequestRepair(data)
        .then((res) => {
          commit("SET_INSERTREQUESTREPAIR", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_UPDATEREQUESTREPAIR: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      updateRequestRepair(data)
        .then((res) => {
          commit("SET_UPDATEREQUESTREPAIR", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_DELETEREQUESTREPAIR: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      deleteRequestRepair(data)
        .then((res) => {
          commit("SET_DELETEREQUESTREPAIR", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_GETREQUESTREPAIR: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        getRequestRepair(data)
        .then((res) => {
          commit("SET_GETREQUESTREPAIR", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_GETREPAIR: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        getRepair(data)
        .then((res) => {
          commit("SET_GETREPAIR", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_UPDATEURGECOUNT: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        updateUrgeCount(data)
        .then((res) => {
          commit("SET_UPDATEURGECOUNT", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_UPDATEREPAIRSTATE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        updateRepairState(data)
        .then((res) => {
          commit("SET_UPDATEREPAIRSTATE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_UPDATECLOSETIME: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        updateCloseTime(data)
        .then((res) => {
          commit("SET_UPDATECLOSETIME", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_GETREPAIRLIST: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        getRepairList(data)
        .then((res) => {
          commit("SET_GETREPAIRLIST", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_UPDATEREPAIRUSER: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        updateRepairUser(data)
        .then((res) => {
          commit("SET_UPDATEREPAIRUSER", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_INSERTREPAIR: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        insertRepair(data)
        .then((res) => {
          commit("SET_INSERTREPAIR", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_ABANDONREQUESTREPAIR: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        abandonRequestRepair(data)
        .then((res) => {
          commit("SET_ABANDONREQUESTREPAIR", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
